import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { Button } from "@ankaadia/ankaadia-shared-frontend";
import { TranslateDirective } from "../../shared/transloco/translate.directive";
import { NewUiNotFoundComponent } from "./new-ui-not-found.component";

@Component({
  selector: "app-not-found",
  templateUrl: "./not-found.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective, RouterLink, Button],
})
export class NotFoundComponent extends NewUiNotFoundComponent {}
